var IconTypes;
(function (IconTypes) {
    IconTypes["addAdmin"] = "addAdmin";
    IconTypes["apps"] = "apps";
    IconTypes["menu"] = "menu";
    IconTypes["info"] = "info";
    IconTypes["backArrow"] = "backArrow";
    IconTypes["upArrow"] = "upArrow";
    IconTypes["downArrow"] = "downArrow";
    IconTypes["rightArrow"] = "rightArrow";
    IconTypes["payment"] = "payment";
    IconTypes["search"] = "search";
    IconTypes["trashcan"] = "trashcan";
    IconTypes["angleLeft"] = "angleLeft";
    IconTypes["angleRight"] = "angleRight";
    IconTypes["favourite"] = "favourite";
    IconTypes["favouriteOutline"] = "favouriteOutline";
    IconTypes["simpleFavourite"] = "simpleFavourite";
    IconTypes["simpleFavouriteOutline"] = "simpleFavouriteOutline";
    IconTypes["newTab"] = "newTab";
    IconTypes["landscape"] = "landscape";
    IconTypes["question"] = "question";
    IconTypes["tick"] = "tick";
    IconTypes["online"] = "online";
    IconTypes["circleTick"] = "circleTick";
    IconTypes["perks"] = "perks";
    IconTypes["logoBox"] = "logoBox";
    IconTypes["close"] = "close";
    IconTypes["oldComment"] = "oldComment";
    IconTypes["oldCommented"] = "oldCommented";
    IconTypes["comment"] = "comment";
    IconTypes["addComment"] = "addComment";
    IconTypes["emoji"] = "emoji";
    IconTypes["emojiActive"] = "emojiActive";
    IconTypes["addEmoji"] = "addEmoji";
    IconTypes["reward"] = "reward";
    IconTypes["customReward"] = "customReward";
    IconTypes["rewardActive"] = "rewardActive";
    IconTypes["addReward"] = "addReward";
    IconTypes["plus"] = "plus";
    IconTypes["vote"] = "vote";
    IconTypes["voted"] = "voted";
    IconTypes["oldReward"] = "oldReward";
    IconTypes["play"] = "play";
    IconTypes["pause"] = "pause";
    IconTypes["attachment"] = "attachment";
    IconTypes["pin"] = "pin";
    IconTypes["pinFilled"] = "pinFilled";
    IconTypes["visibility"] = "visibility";
    IconTypes["perksGO"] = "perksGO";
    IconTypes["wallet"] = "wallet";
    IconTypes["geoPin"] = "geoPin";
    IconTypes["geoArrow"] = "geoArrow";
    IconTypes["summaryComments"] = "summaryComments";
    IconTypes["summaryRecognitions"] = "summaryRecognitions";
    IconTypes["summaryTrophies"] = "summaryTrophies";
    IconTypes["dotDotDot"] = "dotDotDot";
    IconTypes["i"] = "i";
    IconTypes["padlock"] = "padlock";
    IconTypes["lightbulb"] = "lightbulb";
    IconTypes["person"] = "person";
    IconTypes["people"] = "people";
    IconTypes["edit"] = "edit";
    IconTypes["sendExampleSurvey"] = "sendExampleSurvey";
    IconTypes["stop"] = "stop";
    IconTypes["duplicate"] = "duplicate";
    IconTypes["archive"] = "archive";
    IconTypes["launch"] = "launch";
    IconTypes["seeResults"] = "seeResults";
    IconTypes["editQuestion"] = "editQuestion";
    IconTypes["disabledEditQuestion"] = "disabledEditQuestion";
    IconTypes["eyeSlash"] = "eyeSlash";
    IconTypes["eye"] = "eye";
    IconTypes["restore"] = "restore";
    IconTypes["delete"] = "delete";
    IconTypes["mySurveys"] = "mySurveys";
    IconTypes["more"] = "more";
    IconTypes["calendar"] = "calendar";
    IconTypes["ellipsis"] = "ellipsis";
    IconTypes["report"] = "report";
    IconTypes["poll"] = "poll";
    IconTypes["share"] = "share";
    IconTypes["heartOutline"] = "heartOutline";
    IconTypes["send"] = "send";
    IconTypes["tag"] = "tag";
    IconTypes["sort"] = "sort";
    IconTypes["filter"] = "filter";
    IconTypes["filterActive"] = "filterActive";
    IconTypes["removeBookmark"] = "removeBookmark";
    IconTypes["addBookmark"] = "addBookmark";
    IconTypes["user"] = "user";
    IconTypes["logout"] = "logout";
    IconTypes["help"] = "help";
    IconTypes["home"] = "home";
    IconTypes["circleHollow"] = "circleHollow";
    IconTypes["myPerks"] = "myPerks";
    IconTypes["myRecognition"] = "myRecognition";
    IconTypes["dca"] = "dca";
    IconTypes["mobileSecondaryNav"] = "mobileSecondaryNav";
    IconTypes["editPencil"] = "editPencil";
    IconTypes["downloadFile"] = "downloadFile";
    IconTypes["productsPerks"] = "products-perks";
    IconTypes["productsMedical"] = "products-medical";
    IconTypes["productsRecognition"] = "products-recognition";
    IconTypes["productsInsights"] = "products-insights";
    IconTypes["announcement"] = "announcement";
    IconTypes["event"] = "event";
    IconTypes["values"] = "values";
    IconTypes["party"] = "party";
    IconTypes["playVideo"] = "play-video";
    IconTypes["reminder"] = "reminder";
    IconTypes["clipboard"] = "clipboard";
    IconTypes["blog"] = "blog";
    IconTypes["clock"] = "clock";
    IconTypes["newsletter"] = "newsletter";
    IconTypes["fileDownload"] = "fileDownload";
    IconTypes["sharedUser"] = "sharedUser";
})(IconTypes || (IconTypes = {}));
export default IconTypes;
